import { render, staticRenderFns } from "./Alarmsfleet.vue?vue&type=template&id=2f05d17a"
import script from "./Alarmsfleet.vue?vue&type=script&lang=js"
export * from "./Alarmsfleet.vue?vue&type=script&lang=js"
import style0 from "./Alarmsfleet.vue?vue&type=style&index=0&id=2f05d17a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports